export const environment = {
    appVersion: require('../../package.json').version,
    igmsbackgroundlogin: [
        'sign-in-background.jpg',
        'sign-in-background5.jpg',
        'sign-in-background6.jpg',
        'sign-in-background8.png'
    ],
    api_url: 'https://tst-api.oticom.com.br/tst',
    // api_url: 'http://empresaconexao003.ddns.net:7480/v1',
    chave_weblab: '8yT4RcF1',
    router: {
        dashboard: '/oticomweb/dashboard'
    }
};